import React from 'react';
import Image from 'next/image';

import CTA from 'react-scale/components/ui/button';
import useDeviceDetect from 'react-scale/hooks/useDeviceDetect';

import { generalIconsList } from 'react-scale/components/solutions/Icons/GeneralIcons';
import s from './quality-assurance.module.css';

const QualityAssurance = ({ texts, cta, image }) => {
  const { isMobile } = useDeviceDetect();

  return (
    <div className={s.grids}>
      <div className="max-w-[520px] sm:max-w-none flex flex-col justify-center">
        <div className="space-y-16 sm:space-y-8">
          {texts.map(({ header, body }, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index}>
              <div className="flex flex-col items-start mb-5 space-y-5 lg:mb-6 sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0">
                {header?.icon && (
                  <Image
                    src={header.icon.url}
                    alt={header.icon.alt}
                    width={isMobile ? 48 : 45}
                    height={isMobile ? 48 : 45}
                  />
                )}
                <p className="max-w-sm text-2xl lg:text-3xl leading-10 font-aeonik">
                  {header?.title}
                </p>
              </div>
              {body && (
                <p
                  className="mb-8 leading-8 text-gray-400 last:mb-0 lg:text-lg"
                  dangerouslySetInnerHTML={{ __html: body }}
                />
              )}
            </div>
          ))}
        </div>
        {cta && (
          <div className="mt-2 lg:mt-4">
            <CTA href="/sales" text="Talk To Sales" variant="secondary" />
          </div>
        )}
      </div>
      <div className="hidden lg:block">
        <Image
          src={image.src}
          alt={image.alt}
          layout="fixed"
          width={image.width}
          height={image.height}
          quality={100}
          unoptimized
        />
      </div>
      <div className="lg:hidden">
        <Image
          src={image.src}
          alt={image.alt}
          layout="responsive"
          width={image.mobileWidth}
          height={image.mobileHeight}
          quality={100}
          unoptimized
        />
      </div>
    </div>
  );
};

QualityAssurance.defaultProps = {
  bg: 'bg-black',
  overtitle: 'Quality Assurance',
  title: 'Best-In-Class Quality',
  subtitle: 'Industry leading quality datasets safe-guarded against ever-changing, messy data.',
  texts: [
    {
      header: { icon: generalIconsList.personPlus, title: 'Human-Level Accuracy' },
      body: 'AR & VR tasks submitted to the platform are first pre-labeled by our proprietary ML-model, then manually reviewed by highly trained workers depending on the ML model confidence scores. All tasks receive additional layers of both human and ML-driven checks. The resulting accuracy is consistently higher than what a human or synthetic labeling approach can achieve independently.'
    }
  ],
  image: {
    src: '/static/images/pages/document/qa/qa-metrics.svg',
    alt: "Scale's dashboard",
    width: 591,
    height: 687,
    mobileWidth: 591,
    mobileHeight: 687
  }
};

export default QualityAssurance;
